import { useState, useEffect, useCallback } from 'react';
import { countryService } from 'api/services/countryService';
import type { Country } from 'api/types';

export const useCountries = () => {
  const [data, setData] = useState<Country[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchCountries = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await countryService.getAll();
      setData(response.data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchCountries(); }, [fetchCountries]);

  return { data, loading, error, refetch: fetchCountries };
};
